/**
 * 系统管理  公司管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>微信支付配置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
    <!--  <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.deptName" placeholder="输入部门名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item> -->
      <el-form-item>

        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column  prop="departmentName" label="部门名称" >
      </el-table-column>
      <el-table-column  prop="appId" label="appId">
      </el-table-column>
      <el-table-column  prop="appSecret" label="appSecret" >
      </el-table-column>
      <el-table-column  prop="token" label="token">
      </el-table-column>
      <el-table-column  prop="mchId" label="mchId">
      </el-table-column>
      <el-table-column  prop="apiKey" label="apiKey">
      </el-table-column>

      <el-table-column  prop="signType" label="signType">
      </el-table-column>
      <el-table-column  prop="certPath" label="certPath">
      </el-table-column>
      <el-table-column align="center" label="操作" >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteInfo(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog" :close-on-click-modal="false">
      <el-form label-width="100px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="选择部门" prop="depId">
        	<el-select size="small" v-model="editForm.depId">
            <el-option v-for="item in deptData" :label="item.departmentName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="appId" prop="appId">
          <el-input size="small" v-model="editForm.appId" auto-complete="off" placeholder="请输入appId"></el-input>
        </el-form-item>
        <el-form-item label="appSecret" prop="appSecret">
          <el-input size="small" v-model="editForm.appSecret" auto-complete="off" placeholder="请输入appSecret"></el-input>
        </el-form-item>
        <el-form-item label="token" prop="token">
          <el-input size="small" v-model="editForm.token" auto-complete="off" placeholder="请输入token"></el-input>
        </el-form-item>
        <el-form-item label="mchId" prop="mchId">
          <el-input size="small" v-model="editForm.mchId" auto-complete="off" placeholder="请输入mchId"></el-input>
        </el-form-item>
        <el-form-item label="apiKey" prop="apiKey">
          <el-input size="small" v-model="editForm.apiKey" auto-complete="off" placeholder="请输入apiKey"></el-input>
        </el-form-item>
        <el-form-item label="signType" prop="signType">
          <el-input size="small" v-model="editForm.signType" auto-complete="off" placeholder="请输入signType"></el-input>
        </el-form-item>
        <el-form-item label="certPath" prop="certPath">
          <el-input size="small" v-model="editForm.certPath" auto-complete="off" placeholder="请输入certPath"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deptList,saveWXInfo,findWxInfo,deleteWxInfo,updateWXInfo} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      deptData:[],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        depId: '',
        appId:"",
        appSecret:"",
        token:"",
        mchId:"",
        apiKey:"",
        signType:"",
        certPath:""
      },
      dataList:[],
      // rules表单验证
      rules: {
        depId: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ],

      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total:0
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getDeptDataList()
    this.getData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getData() {
      findWxInfo(this.pageparm).then(res => {
        if(res.status == 1){
          this.dataList = res.data.data
          this.pageparm.total = res.data.totalCount
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    getDeptDataList:function(){
    	deptList().then(res => {
    		if(res.status == 1){
    			this.deptData = res.data
    		}else{
    			this.$message.error(res.msg)
    		}
    	})
    },


    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.currentPage = parm.pageSize

    },
    // 搜索事件
    search() {

    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.depId = row.depId
        this.editForm.appId = row.appId
        this.editForm.appSecret = row.appSecret
        this.editForm.token = row.token
        this.editForm.mchId = row.mchId
        this.editForm.apiKey = row.apiKey
        this.editForm.signType = row.signType
        this.editForm.certPath = row.certPath


      } else {
        this.title = '添加'
      this.editForm.id = ""
      this.editForm.depId = ""
      this.editForm.appId = ""
      this.editForm.appSecret = ""
      this.editForm.token = ""
      this.editForm.mchId = ""
      this.editForm.apiKey = ""
      this.editForm.signType = ""
      this.editForm.certPath = ""
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.title == '添加'){
            this.saveData()
          }else{
            this.upDateData()
          }

        } else {
          return false
        }
      })
    },
    saveData(){
      saveWXInfo(this.editForm)
        .then(res => {
          this.loading = false
          this.editFormVisible = false

          if (res.status == 1) {
            this.$message({
              type: 'success',
              message: '添加成功！'
            })
            this.getData()
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
    },

    upDateData(){
      updateWXInfo(this.editForm)
        .then(res => {
          this.loading = false
          this.editFormVisible = false

          if (res.status == 1) {
            this.$message({
              type: 'success',
              message: '修改成功！'
            })
            this.getData()
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
    },

    deleteInfo(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteWxInfo({wxInfoId:row.id})
            .then(res => {
              if(res.status == 1){
                this.$message.success('删除成功')
                this.getData()
              }else{
                this.$message.error(res.msg)
              }
            })

        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>

.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/system/wxPay.vue